import React from 'react';
import styled from 'styled-components';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { PrimaryButton } from '@utmost.co/utmost-design-system/src/components/Button';
import { SystemIcon } from '@utmost.co/utmost-design-system/src/components/Icon';
import { CardContent, CardHeader, Card } from '@utmost.co/utmost-design-system/src/components/Card';
import { useCommonIntl } from 'common/translations/useCommonIntl';
import { FallbackRender } from '@sentry/react';

const FallBackErrorBoundary: FallbackRender = ({ error, componentStack, resetError }) => {
  const intl = useCommonIntl();
  return (
    <StyledContainer>
      <StyledContent>
        <Card>
          <CardHeader
            avatar={<SystemIcon name="error" size="large" style={{ color: tokens.colorAlert }} />}
            title={intl.somethingWentWrong}
            subheader={<StyledErrorContainer>{error?.toString() ?? ''}</StyledErrorContainer>}
            subheaderTypographyProps={{ variant: 'subtitle2' }}
          />
          <CardContent>
            <StyledError>
              {error?.toString() ?? ''}
              <br />
              {componentStack}
            </StyledError>
            <PrimaryButton.Contained
              onClick={() => {
                resetError();
              }}
            >
              {intl.tryAgain}
            </PrimaryButton.Contained>
          </CardContent>
        </Card>
      </StyledContent>
    </StyledContainer>
  );
};

export default FallBackErrorBoundary;

const StyledContainer = styled.div`
  background-color: rgb(239, 239, 239);
  position: relative;
  min-height: 300px;
  height: 100%;
  width: 100%;
`;

const StyledErrorContainer = styled.div`
  max-height: 500px;
  overflow: auto;
`;

const StyledContent = styled.div`
  max-width: 960px;
  width: 50%;
  margin: 0 auto;
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
  max-height: 100%;
  overflow: auto;
`;

const StyledError = styled.pre`
  max-height: 300px;
  overflow: auto;
  user-select: text;
`;
